const PaginationTable = (resolve:any) => {  require(['./pagination_table/index.vue'], resolve) }
const VsonNEditor = (resolve:any) => {  require(['./vson_neditor/index.vue'], resolve) }
const VsonUpload = (resolve:any) => {  require(['./vson_upload/index.vue'], resolve) }
const AsyncPaginationSelect= (resolve:any) => {  require(['./async_pagination_select/index.vue'], resolve) }

export {
  PaginationTable,
  VsonNEditor,
  VsonUpload,
  AsyncPaginationSelect
}
